module.exports = "/assets/data/14c690d0328785ff72b75960abae3eef-DE21.data.json";